"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchShutterstock = searchShutterstock;

var _immutable = _interopRequireDefault(require("immutable"));

var _Shutterstock = require("FileManagerCore/api/Shutterstock");

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

function searchShutterstock(options) {
  var query = _immutable.default.Map(options);

  return function (dispatch) {
    if (query.get('searchQuery') === '') {
      dispatch({
        type: _ActionTypes.default.SEARCH_SHUTTERSTOCK_RESET
      });
      return;
    }

    dispatch({
      type: _ActionTypes.default.SEARCH_SHUTTERSTOCK_ATTEMPTED,
      page: query.get('page'),
      pageSize: query.get('pageSize'),
      query: query
    });
    (0, _Shutterstock.search)(options).then(function (response) {
      dispatch({
        type: _ActionTypes.default.SEARCH_SHUTTERSTOCK_SUCCEEDED,
        data: response,
        page: query.get('page'),
        query: query
      });
    }, function (error) {
      dispatch({
        type: _ActionTypes.default.SEARCH_SHUTTERSTOCK_FAILED,
        page: query.get('page'),
        error: error,
        query: query
      });
    }).done();
  };
}